import Axios from 'axios'
import { getPathName, getApiHash, getApiToken } from './helper';

const descargarPoliza = async (idPoliza: number, rubro: string = "AUTO") => {
    const params = {
        hash: await getApiHash(),
        idPoliza: idPoliza
    }
    const headers = {
        'content-type': 'application/json',
        "Authorization": 'Bearer ' + await getApiToken()
    }

    const endpoint = rubro === "AUTO" ? "/GetImpresionPolizaJSON" : `/GetImpresionPoliza${rubro}JSON` 
    return await Axios.post(await getPathName() + endpoint, params,
        {
            headers: headers
        }).then(function (response) {
            return response.data;
        }).catch(function (error) {
            return error;
        });
};

export default descargarPoliza;